import Navbar from "@/components/Navbar";
import { Card, CardContent } from "@/components/ui/card";
import { MapPin, Phone, Globe, Instagram, Facebook } from "lucide-react";

const ContactUs = ({ user, onLogout }) => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white">
      <Navbar user={user} onLogout={onLogout} />
      <div className="p-6" dir="rtl">
      <div className="max-w-4xl mx-auto">
        {/* Banner */}
        <div className="rounded-2xl overflow-hidden shadow-xl mb-10 max-w-2xl mx-auto">
          <img 
            src="/company-banner.jpeg" 
            alt="شركة التمكين للاستشارات والخدمات القانونية" 
            className="w-full h-auto object-cover"
          />
        </div>

        {/* Title */}
        <div className="text-center mb-10">
          <h1 className="text-4xl font-bold text-slate-900 mb-2">تواصل معنا</h1>
          <p className="text-lg text-slate-500">نرافقك بخبرة، ندافع عن حقوقك، ونصنع لك الحل المناسب</p>
        </div>

        {/* Contact Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10">
          {/* WhatsApp */}
          <a href="https://wa.me/9647904207503" target="_blank" rel="noopener noreferrer" data-testid="contact-whatsapp">
            <Card className="hover:shadow-lg transition-shadow cursor-pointer border-green-200 hover:border-green-400">
              <CardContent className="flex items-center gap-4 p-6">
                <div className="w-14 h-14 rounded-full bg-green-100 flex items-center justify-center shrink-0">
                  <Phone className="w-7 h-7 text-green-600" />
                </div>
                <div>
                  <h3 className="font-bold text-slate-900 text-lg">واتساب</h3>
                  <p className="text-slate-500 text-sm" dir="ltr">+964 790 420 7503</p>
                </div>
              </CardContent>
            </Card>
          </a>

          {/* Website */}
          <a href="https://www.altamkeenlegal.com" target="_blank" rel="noopener noreferrer" data-testid="contact-website">
            <Card className="hover:shadow-lg transition-shadow cursor-pointer border-blue-200 hover:border-blue-400">
              <CardContent className="flex items-center gap-4 p-6">
                <div className="w-14 h-14 rounded-full bg-blue-100 flex items-center justify-center shrink-0">
                  <Globe className="w-7 h-7 text-blue-600" />
                </div>
                <div>
                  <h3 className="font-bold text-slate-900 text-lg">الموقع الرسمي</h3>
                  <p className="text-slate-500 text-sm">www.altamkeenlegal.com</p>
                </div>
              </CardContent>
            </Card>
          </a>

          {/* Instagram */}
          <a href="https://www.instagram.com/thisistamkeen?igsh=eGR1aG1sa29rcmZq" target="_blank" rel="noopener noreferrer" data-testid="contact-instagram">
            <Card className="hover:shadow-lg transition-shadow cursor-pointer border-pink-200 hover:border-pink-400">
              <CardContent className="flex items-center gap-4 p-6">
                <div className="w-14 h-14 rounded-full bg-pink-100 flex items-center justify-center shrink-0">
                  <Instagram className="w-7 h-7 text-pink-600" />
                </div>
                <div>
                  <h3 className="font-bold text-slate-900 text-lg">انستغرام</h3>
                  <p className="text-slate-500 text-sm">@thisistamkeen</p>
                </div>
              </CardContent>
            </Card>
          </a>

          {/* Facebook */}
          <a href="https://www.facebook.com/share/1B2rv8vZ5b/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" data-testid="contact-facebook">
            <Card className="hover:shadow-lg transition-shadow cursor-pointer border-blue-200 hover:border-blue-400">
              <CardContent className="flex items-center gap-4 p-6">
                <div className="w-14 h-14 rounded-full bg-blue-100 flex items-center justify-center shrink-0">
                  <Facebook className="w-7 h-7 text-blue-700" />
                </div>
                <div>
                  <h3 className="font-bold text-slate-900 text-lg">فيسبوك</h3>
                  <p className="text-slate-500 text-sm">شركة التمكين للاستشارات و الخدمات القانونية</p>
                </div>
              </CardContent>
            </Card>
          </a>
        </div>

        {/* Location */}
        <Card className="border-slate-200" data-testid="contact-location">
          <CardContent className="flex items-center gap-4 p-6">
            <div className="w-14 h-14 rounded-full bg-red-100 flex items-center justify-center shrink-0">
              <MapPin className="w-7 h-7 text-red-600" />
            </div>
            <div>
              <h3 className="font-bold text-slate-900 text-lg">العنوان</h3>
              <p className="text-slate-600">اليرموك - الأربع شوارع / خدمي تقاطع الأردن</p>
            </div>
          </CardContent>
        </Card>
      </div>
      </div>
    </div>
  );
};

export default ContactUs;
